import React, {useState} from 'react'
import {Column, Row} from "simple-flexbox";
import {Button } from "@material-ui/core";
import CustomInput from "../../common/components/CustomInput";
import {history} from "../../managers/history";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from 'material-ui/IconButton';
import { sessionManager } from "../../managers/sessionManager";
import {actionTypeConstant, cookiesConstants, genericConstants, userRoles} from "../../constants/index";





function LoginForm(props) {
    let {state, onChangeEvent, onLoginClicked, onChangeChecked} = props;
    const [passwordShown, setPasswordShown] = React.useState(false);
    const togglePasswordVisiblity = () => {
      setPasswordShown(passwordShown ? false : true);
     
  
    };
    return (
        
        <Column className="loginform  pt-5 align-items-center mt-5 w-520 " horizontal={'center'} >
             <img src="/RealsNFT.svg" alt='Logo' className="w-120"/>
            <form onSubmit={(event)=> onLoginClicked(event)} className="w-100 form p-3">
                <Row className="justify-content-center w-100 fs-16 fc-1f1f1f h-22">
                Sign In to your Account
                </Row>

                <div className="fc-dark-slate-blue fs-16 mt-3 email w-48">Email:</div>
                <CustomInput id="email" type="text" value={ state && state.email} onChange={onChangeEvent}
                             error={state ? state.emailError : ""} className="fs-16 p-2 mt-6 h-55 bg-eee"
                             required={true}/>

                <Row className="fs-15 mt-9 justify-content-between">
                    <div className="fc-dark-slate-blue password">Password:</div>
                    <div className="fc-blue cursor-pointer">
                        {state && state.isPasswordVisible  }
                    </div>
                </Row>
                <div className='input-border display-flex mt-6 align-items-center bg-rgb32'>
                <input id="password"  type={state && state.isPasswordVisible ? "text" : "password"}
                             value={state && state.password} onChange={onChangeEvent}
                             error={state ? state.passwordError : ""} className="fs-15 border-0 p-2  h-55 bg-eee w-100 outline-none  " required={true}/>
                            <span  onClick={()=>props.togglePassword() } className="mr-13"> {passwordShown ? <VisibilityIcon fontSize="small" style={{ color: "#1f1f1f" }} onClick={togglePasswordVisiblity} /> : <VisibilityOff  fontSize="small" style={{ color: "#1f1f1f" }} onClick={togglePasswordVisiblity} />}</span>
               
                </div>
                   <span className='fc-red'>{state.passwordError}</span> 
                <Row vertical={'center'} className="mb-1 mt-1">
                    <input  id="isRememberMeSelected"  name="isChecked" checked={state.isChecked} onClick={(event)=>onChangeChecked(event)} type="checkbox" 
                           className="checkbox-border p-3 box-1 w-15 h-15"/>
                    <Column className="ml-2  fc-blue-grey font-weight-normal remember pl-4" >Remember Me</Column>
                </Row>
                <Row className="w-100 justify-content-left pb-14">
                    <a href="" onClick={props.routeChange} className="forget">Forget Password?</a>
                </Row>

                <Button type='submit' className="bg-blue outline-none text-transform-capitalize
                fc-white w-100 py-2 fs-16 my-3 cursor-pointer loginbtn h-63" >
                    Log in
                </Button>
               
            </form>
        </Column>
        
    );
}

function HeaderComponent(props) {
    return (
        <Row vertical="center" className="justify-content-between">
           
            <Row vertical="center">
                {/* <Column vertical="center" className="fc-brownish-grey fs-15 px-2 py-1">New user?</Column> */}
                {/* <Column vertical="center" className="fc-blue br-4 b-1-blue fs-17 px-2 py-1 cursor-pointer"
                        onClick={() => history.replace("/sign-up")}>
                    Sign Up
                </Column> */}
            </Row>
        </Row>
    )
}

function loginComponent(props) {
    return (
        <Column horizontal={'center'} className="w-100 p-3 min-vh-100 h-100 justify-content-between">
            <Column className="w-100">
                {HeaderComponent(props)}
                <Row horizontal="center" className="loginStyle w-100 my-5">
                    {LoginForm(props)}
                </Row>
            </Column>
            {/* <Column className="jc-center w-100 align-items-center fs-14 my-3">
                <div className="fc-warm-grey">©2019 LIMB CRE. All Rights Reserved.</div>
                <div className="fc-blue">Privacy Policy</div>
            </Column> */}
        </Column>
    );
}

export default loginComponent;